export default __webpack_public_path__ + "static/media/image26tum.632a727e.jpg";